(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
     
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const revealSelectors = [
      '.caseno-authorized-editorial__item',
      '.caseno-pagani-description__inner .pagani-detail-card',
      '.caseno-pagani-description__inner .pagani-benefit-list',
      '.caseno-pagani-description__inner .pagani-spec-table',
      '.caseno-technical-specifications__inner',
      '.caseno-video-showcase__inner'
    ];

    const initCasenoScrollReveal = () => {
      const elements = document.querySelectorAll(revealSelectors.join(','));

      if (!elements.length) return;

      if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.16
        }
      );

      elements.forEach((element) => {
        element.classList.add('caseno-scroll-reveal');
        observer.observe(element);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCasenoScrollReveal, { once: true });
    } else {
      initCasenoScrollReveal();
    }

    document.addEventListener('shopify:section:load', initCasenoScrollReveal);
  })();

  (() => {
    const normalizeImageKey = (source) => {
      if (!source) return '';

      try {
        const url = new URL(source, window.location.origin);
        return url.pathname.split('/').pop() || '';
      } catch (error) {
        return source.split('?')[0].split('/').pop() || '';
      }
    };

    const initCasenoProductZoom = (scope = document) => {
      scope.querySelectorAll('[data-caseno-product-zoom]').forEach((dialog) => {
        if (dialog.dataset.casenoProductZoomReady === 'true') return;

        const section = dialog.closest('section');
        const gallery = section ? section.querySelector('.product__media-wrapper') : null;
        const slides = Array.from(dialog.querySelectorAll('[data-caseno-zoom-slide]'));
        const closeButton = dialog.querySelector('[data-caseno-zoom-close]');
        const previousButton = dialog.querySelector('[data-caseno-zoom-prev]');
        const nextButton = dialog.querySelector('[data-caseno-zoom-next]');
        const counter = dialog.querySelector('[data-caseno-zoom-counter]');

        if (!gallery || !slides.length) return;

        dialog.dataset.casenoProductZoomReady = 'true';

        const slideKeys = slides.map((slide) => {
          const image = slide.querySelector('[data-caseno-zoom-image]');
          return normalizeImageKey(image ? image.currentSrc || image.src : '');
        });

        let activeIndex = 0;

        const setActive = (index) => {
          activeIndex = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== activeIndex;
          });

          if (counter) {
            counter.textContent = `${activeIndex + 1} / ${slides.length}`;
          }

          if (previousButton) {
            previousButton.hidden = slides.length < 2;
          }

          if (nextButton) {
            nextButton.hidden = slides.length < 2;
          }
        };

        const indexFromImage = (image) => {
          const mediaElement = image.closest('[data-media-id]');
          const mediaId = mediaElement ? String(mediaElement.dataset.mediaId || '') : '';

          if (mediaId) {
            const mediaIndex = slides.findIndex((slide) => mediaId.endsWith(String(slide.dataset.mediaId || '')));
            if (mediaIndex >= 0) return mediaIndex;
          }

          const key = normalizeImageKey(image.currentSrc || image.src);
          const keyIndex = slideKeys.findIndex((slideKey) => slideKey === key);

          if (keyIndex >= 0) return keyIndex;

          const galleryImages = Array.from(gallery.querySelectorAll('img')).filter((galleryImage) => {
            return !galleryImage.closest('.thumbnail-list, .thumbnail-slider, .thumbnail');
          });

          return Math.max(0, galleryImages.indexOf(image));
        };

        const open = (index) => {
          setActive(index);
          document.body.classList.add('caseno-product-zoom-open');

          if (dialog.open) return;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }

          const activeImage = slides[activeIndex].querySelector('img');
          if (activeImage) activeImage.focus({ preventScroll: true });
        };

        const close = () => {
          document.body.classList.remove('caseno-product-zoom-open');

          if (typeof dialog.close === 'function' && dialog.open) {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        };

        gallery.querySelectorAll('img').forEach((image) => {
          if (image.closest('.thumbnail-list, .thumbnail-slider, .thumbnail')) return;
          if (!image.closest('button, a')) {
            image.setAttribute('role', 'button');
            image.setAttribute('tabindex', '0');
          }
          image.setAttribute('aria-label', 'Abrir zoom da imagem do produto');
        });

        gallery.addEventListener('click', (event) => {
          const image = event.target.closest('img');

          if (!image || !gallery.contains(image)) return;
          if (image.closest('.thumbnail-list, .thumbnail-slider, .thumbnail')) return;
          if (image.closest('model-viewer, deferred-media, video')) return;

          event.preventDefault();
          open(indexFromImage(image));
        });

        gallery.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          const image = event.target.closest('img');
          if (!image || !gallery.contains(image)) return;
          if (image.closest('.thumbnail-list, .thumbnail-slider, .thumbnail')) return;

          event.preventDefault();
          open(indexFromImage(image));
        });

        if (closeButton) {
          closeButton.addEventListener('click', close);
        }

        if (previousButton) {
          previousButton.addEventListener('click', () => setActive(activeIndex - 1));
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => setActive(activeIndex + 1));
        }

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) close();
        });

        dialog.addEventListener('cancel', () => {
          document.body.classList.remove('caseno-product-zoom-open');
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setActive(activeIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            setActive(activeIndex + 1);
          }
        });

        setActive(0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCasenoProductZoom(), { once: true });
    } else {
      initCasenoProductZoom();
    }

    document.addEventListener('shopify:section:load', (event) => initCasenoProductZoom(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
